export default __webpack_public_path__ + "static/media/Picture 5.ac1843de.svg";